<template>
    <b-card-body>
        <div v-for="(item, idx) in filteredItemTypeOptions" :key="item.id">
            <b-btn
                block
                href="#"
                v-b-toggle="'accordion' + item.id"
                variant="light"
                class="text-left"
            >
                <span v-if="accordianModelArray[idx]"
                    ><b-icon icon="dash-square"></b-icon
                ></span>
                <span v-else><b-icon icon="plus-square-fill"></b-icon></span>
                <span> {{ item.name }}</span>
            </b-btn>

            <b-collapse
                :id="'accordion' + item.id"
                role="tabpanel"
                v-model="accordianModelArray[idx]"
            >
                <DisplayOrderItems
                    @toggleAssignment="hideTotals = $event"
                    :filtered-items="
                        storedItems.filter(x => x.order_item_type_id == item.id)
                    "
                    :customer-assets="order.assets"
                    :item-type-id="item.id"
                    @view-item="setItemView"
                    @order-status="getOrderCompletionStatus"
                >
                </DisplayOrderItems>
            </b-collapse>
            <view-item
                :order-model="order"
                ref="viewItem"
                :officer="officer"
                :customer-assets="order.assets"
            />
        </div>
        <div>
            <b-row v-if="storedItems.length != 0">
                <b-col cols="9">
                    <b class="float-right">Total</b>
                </b-col>
                <b-col cols="3" style="text-align: right">
                    <b>${{ orderPricing.total | currency }}</b>
                </b-col>
            </b-row>

            <b-row v-if="storedItems.length != 0">
                <b-col cols="9">
                    <b class="float-right">Total Tax</b>
                </b-col>
                <b-col cols="3" style="text-align: right">
                    <span>${{ orderPricing.tax | currency }}</span>
                </b-col>
            </b-row>

            <b-row v-if="storedItems.length != 0">
                <b-col cols="9">
                    <b class="float-right">Grand Total</b>
                </b-col>
                <b-col cols="3" style="text-align: right">
                    <b
                        >${{
                            (orderPricing.tax + orderPricing.total) | currency
                        }}</b
                    >
                </b-col>
            </b-row>
        </div>
    </b-card-body>
</template>

<script>
import DisplayOrderItems from '../Orders/DisplayOrderItems.vue'
import ViewItem from '../Orders/ViewItem.vue'

export default {
    name: 'service-request-items',
    components: {
        DisplayOrderItems,
        ViewItem,
    },
    props: ['order'],
    data() {
        return {
            accordianModelArray: [],
            fields: [
                'id',
                'name',
                'order_item_type_id',
                'quantity',
                'uom',
                { key: 'quantity', label: 'Qty' },
                'price',
                { key: 'tax_rate', label: 'Tax' },
            ],
            hideTotals: false,
            items: [],
        }
    },
    methods: {
        loaditems(items) {
            console.log('service request items', items)
            const cloneItems = []
            for (const item of items) {
                const _item = { ...item }
                const assets = _item.assets.map(i => i.asset_id)
                this.$set(_item, 'assets', assets)
                cloneItems.push(_item)
            }
            console.log('cloneitems', cloneItems)
            this.$store.dispatch('orderItemStore/load', cloneItems)
        },
        getOrderCompletionStatus(value) {
            console.log('^^^^^^^^^^^ Completion Status', value)
        },
        getLoadedItemTypes(orderItems) {
            const itemTypes = orderItems

            console.log('ACTIVITY ITEM TYPES LOADED: ', itemTypes)
            return itemTypes
        },

        generateItems(items) {
            this.accordianModelArray.splice(0)
            this.accordianModelArray.push(
                ...[...Array(items.length).keys()].map(() => true)
            )

            console.log('accordion model', this.accordianModelArray)
        },
        setItemView(hash) {
            console.log('item hash', hash)
            const item = this.storedItems.find(x => x.hash === hash)
            this.$refs['viewItem'] && this.$refs['viewItem'].showItem(item)
        },
    },

    filters: {
        currency: num => {
            num = parseFloat(num)
            try {
                return num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
            } catch (err) {
                return '0.00'
            }
        },
    },
    watch: {
        filteredItemTypeOptions: {
            handler: function (val) {
                this.generateItems(val)
            },
            deep: true,
        },
    },

    computed: {
        orderPricing() {
            return this.$store.getters['orderItemStore/orderPricing']
        },
        storedItems() {
            return this.$store.state.orderItemStore.items
        },

        itemTypes() {
            return this.$store.state.itemType.items
        },

        officer() {
            return this.$store.state.users.user
        },

        filteredItemTypeOptions() {
            const { itemTypes } = this

            if (!itemTypes) return []
            const onlyUnique = (value, index, array) =>
                array.indexOf(value) === index

            const selectedItemType = id => itemTypes.find(t => t.id == id)

            const list = this.storedItems
                .map(i => i.order_item_type_id)
                .filter(onlyUnique)
                .map(selectedItemType)

            console.log('filteredItemTypeOptions', list)

            return list
        },
    },
    mounted() {
        console.log('order is', this.order)
        this.$store.dispatch('itemType/fetchAll')

        this.items = this.order.items
        this.loaditems(this.order.items, 'mounted')
        this.loadedItemTypes = this.getLoadedItemTypes(this.order.items)
        console.log('this.storedItems', this.storedItems)
        this.generateItems(this.filteredItemTypeOptions)
    },
}
</script>
